import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ListaCTComponent } from './lista-ct.component';


// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
import { PdfreporteComponent } from './reporte/pdfreporte/pdfreporte.component';

const rutas: Routes = [
    // trust index
    {
        path     : 'NOM35/lista-cdt',
        component: ListaCTComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
  declarations: [ListaCTComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    FlexLayoutModule,
    MatProgressBarModule,
    TranslateModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule
  ]
})
export class ListaCTModule { }
